import React, { Component } from "react";
import CustomAlert from "../custom/custom_alert";
import AppConfig from "../../AppConfig";
import { toast } from "react-toastify";
import { LoaderFull } from "../LoaderFull";

export class Staff extends Component {
  constructor(props) {
    super(props);
    this.state = {
      edit: props.edit === true,
      loading: false,
      upLoading: false,
      obj: {},
      companies: [],
      projects: [],
      project_Id: 0,
      _Id: "",
      msg: "",
      msgColor: AppConfig.messageColors.success,
    };
    this.formRef = React.createRef();
  }

  componentDidMount() {
    this.populateProjectsData();
    this.populateData();
  }

  async populateData() {
    if (this.props._Id === undefined || this.props._Id === null) return;
    this.setState({
      loading: true,
    });
    var result = await AppConfig.PostData("staffs/" + this.props._Id, "GET");
    //  console.log(result)
    this.setState({
      loading: false,
    });
    if (result["error"] !== undefined) {
      toast.error(result["error"]);
    } else if (result["data"] === undefined) {
      toast.warn("No result found");
    } else {
      this.setState({
        obj: result["data"],
      });
    }
  }

  async populateProjectsData() {
    this.setState({ loadingMain: true });
    var url = `projects`;

    var result = await AppConfig.PostData(url, "GET");
    //  console.log(result)
    if (result["error"] !== undefined) {
      toast(result["status"]);
    } else {
      this.setState({
        projects: result["data"],
      });
      if (result["data"].length === 0) {
        toast.warn("No projects was found");
      } else {
        this.setState({ project_Id: result["data"][0].id });
        AppConfig.setProjectId(result["data"][0].id);
        this.populateAllCompaniesData();
      }
    }
    this.setState({
      loadingMain: false,
    });
  }

  async populateAllCompaniesData() {
    this.setState({ loadingMain: true });
    var url =
      `companies?` +
      new URLSearchParams({
        status: this.state.status,
      });

    var result = await AppConfig.PostData(url, "GET");
    //  console.log(result)
    if (result["error"] !== undefined) {
      toast(result["status"]);
    } else {
      if (result["data"].length === 0) {
        toast.warn("No company was found");
      }

      this.setState({
        companies: result["data"],
      });
    }
    this.setState({
      loadingMain: false,
    });
  }

  async submitData() {
    AppConfig.setProjectId(this.state.project_Id);
    if (AppConfig.getAccessRole() !== "admin") return;
    this.setState({ msgColor: AppConfig.messageColors.warning });
    if (!this.state.obj.id || String(this.state.obj?.id).length === 0) {
      toast("Id is required!");
      return;
    }
    if (
      !this.state.obj.civilId ||
      String(this.state.obj?.civilId).length === 0
    ) {
      toast("Civil Id is required!");
      return;
    }
    if (!this.state.obj.name || this.state.obj.name?.length === 0) {
      toast("Name is required!");
      return;
    }
    // if (this.state.obj.company_Id === "") {
    //   this.setState({ msg: "company is required!" });
    //   return;
    // }

    //Set project Id if not set
    var project_Id = this.state.project_Id;
    if (project_Id <= 0 && this.state.projects.length === 0) {
      this.setState({ msg: "Project is required!" });
      return;
    }
    if (project_Id <= 0) {
      project_Id = this.state.projects[0].id;
    }
    AppConfig.setProjectId(project_Id);

    this.setState({
      upLoading: true,
    });

    var url =
      "staffs" +
      (this.props._Id === undefined || this.props._Id === null
        ? ""
        : "/" + this.props._Id);
    var method =
      this.props._Id === undefined || this.props._Id === null ? "POST" : "PUT";

    const body = JSON.stringify({
      id: this.state.obj.id,
      civilId: this.state.obj.civilId,
      name: this.state.obj.name,
      nameLocal: this.state.obj.nameLocal,
      company_Id: this.state.obj.company_Id,
      phone: this.state.obj.phone,
      email: this.state.obj.email,
      address: this.state.obj.address,
    });

    var result = await AppConfig.PostData(url, method, body);
    if (result["exception"] !== undefined || result["error"] !== undefined) {
      toast.error(result["error"]);
    } else if (
      result["result"] === "success" ||
      result["result"] === true ||
      result["data"] !== undefined
    ) {
      toast(AppConfig.messages.success);
      if (this.props._Id === undefined) {
        var obj = this.state.obj;
        obj.id = "";
        obj.name = "";
        obj.civilId = "";
        obj.nameLocal = "";
        obj.phone = "";
        obj.email = "";
        obj.address = "";
        this.setState({ obj });
      }
    } else {
      toast(result["message"]);
    }
    this.setState({
      upLoading: false,
    });
  }

  handleDetailsChange = (input, e) => {
    var obj = this.state.obj;
    obj[input] = e.target.value;
    this.setState({ obj });
  };

  renderData(obj) {
    return (
      <form
        onSubmit={(e) => {
          e.preventDefault();
          this.submitData();
        }}
      >
        <fieldset id="fieldset" className="p-4 col-md-4" ref={this.formRef} disabled={!this.state.edit}>
          <div className="row">
            <div className="form-group">
              <label className="form-label">Project</label>

              <select
                className="form-select form-control"
                onChange={(e) => {
                  this.setState({ project_Id: e.target.value });
                  AppConfig.setProjectId(e.target.value);
                  this.populateAllCompaniesData();
                }}
              >
                {this.state.projects.map((p) =>
                  obj.project_Id === p.id ? (
                    <option value={p.id} selected>
                      {p.name}
                    </option>
                  ) : (
                    <option value={p.id}>{p.name}</option>
                  )
                )}
              </select>
            </div>
            <div className="form-group">
              <label className="form-label">ID Number</label>
              <input
                type="text"
                className="form-control"
                placeholder="ID Number"
                aria-label="ID Number"
                autoFocus
                aria-describedby="basic-addon1"
                value={obj.id}
                onChange={(e) => this.handleDetailsChange("id", e)}
              />
            </div>
            <div className="form-group">
              <label className="form-label">Civil Id</label>
              <input
                type="text"
                className="form-control"
                placeholder="Civil Id"
                aria-label="Civil Id"
                aria-describedby="basic-addon1"
                value={obj.civilId}
                onChange={(e) => this.handleDetailsChange("civilId", e)}
              />
            </div>
            <div className="form-group">
              <label className="form-label">Name</label>
              <input
                type="text"
                className="form-control"
                placeholder="Name"
                aria-label="Name"
                autoFocus
                aria-describedby="basic-addon1"
                value={obj.name}
                onChange={(e) => this.handleDetailsChange("name", e)}
              />
            </div>
            <div className="form-group">
              <label className="form-label">الاسم</label>
              <input
                type="text"
                className="form-control"
                placeholder="الاسم"
                aria-label="الاسم"
                autoFocus
                aria-describedby="basic-addon1"
                value={obj.nameLocal}
                onChange={(e) => this.handleDetailsChange("nameLocal", e)}
              />
            </div>
            <div className="form-group">
              <label className="form-label">Company</label>
              <select
                className="form-select form-control"
                aria-label="Company"
                aria-describedby="basic-addon1"
                value={obj.company_Id}
                onChange={(e) => this.handleDetailsChange("company_Id", e)}
              >
                <option value="" selected disabled>
                  Select a Company
                </option>
                {this.state.companies.map((company, index) =>
                  obj?.company_Id === company.id ? (
                    <option key={index} value={company.id} selected>
                      {company.name}
                    </option>
                  ) : (
                    <option key={index} value={company.id}>
                      {company.name}
                    </option>
                  )
                )}
              </select>
            </div>
            <div className="form-group">
              <label className="form-label">Phone</label>
              <input
                type="text"
                className="form-control"
                placeholder="Phone"
                aria-label="Phone"
                aria-describedby="basic-addon1"
                value={obj.phone}
                onChange={(e) => this.handleDetailsChange("phone", e)}
              />
            </div>
            <div className="form-group">
              <label className="form-label">Email</label>
              <input
                type="text"
                className="form-control"
                placeholder="Email"
                aria-label="Email"
                aria-describedby="basic-addon1"
                value={obj.email}
                onChange={(e) => this.handleDetailsChange("email", e)}
              />
            </div>
            <div className="form-group">
              <label className="form-label">Address</label>
              <input
                type="text"
                className="form-control"
                placeholder="Address"
                aria-label="Address"
                aria-describedby="basic-addon1"
                value={obj.address}
                onChange={(e) => this.handleDetailsChange("address", e)}
              />
            </div>
            {!this.state.edit && this.props._Id !== undefined && (
              <div className="row">
                <div className="col-md-6 p-2">
                  <label className="form-label">Active</label>
                  <div className="input-group mb-3">
                    <div className="input-group-prepend">
                      <span className="input-group-text" id="basic-addon1">
                        {obj.status && (
                          <i className="fa fa-check text-success"></i>
                        )}
                        {!obj.status && (
                          <i className="fa fa-close text-danger"></i>
                        )}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </fieldset>

        {this.state.msg !== "" && (
          <CustomAlert
            msg={this.state.msg}
            type={this.state.msgColor}
            Remove={() => {
              this.setState({ msg: "" });
            }}
          />
        )}
        <div className="card-footer p-4">
          {!this.state.upLoading &&
            ((this.props._Id !== null && this.state.edit === true) ||
              this.props._Id === undefined) && (
              <button className="btn btn-success col-md-3" type="submit">
                <i className="fa fa-save me-2"></i>
                {this.props._Id === undefined && <span>Save Changes</span>}
                {this.props._Id !== undefined && <span>Update Item</span>}
              </button>
            )}
          {this.state.upLoading && (
            <button disabled className="btn btn-primary col-md-3">
              <i className="fa fa-spinner fa-spin me-2"></i>
              Saving Changes...
            </button>
          )}
          <div className="mt-2 pt-2 border-top">
            {this.props._Id != null && this.state.edit !== true && (
              <a
                href={"authorize/Staff/edit/" + this.props._Id}
                className="btn btn-sm btn-primary rounded m-2"
              >
                <i className="fa fa-edit me-2"></i>
                Edit Staff
              </a>
            )}
            {this.props._Id !== undefined && (
              <a
                href="authorize/Staff"
                className="btn btn-sm btn-primary rounded m-2"
              >
                <i className="fa fa-plus me-2"></i>
                New Staff
              </a>
            )}
            <a
              href="authorize/staffs"
              className="btn btn-sm btn-primary rounded m-2"
            >
              <i className="fa fa-close me-2"></i>
              Back to Staffs
            </a>
          </div>
        </div>
      </form>
    );
  }

  render() {
    let contents = this.state.loading ? (
      <LoaderFull />
    ) : (
      this.renderData(this.state.obj)
    );

    return (
      <div>
        <div
          className="row justify-content-center"
          aria-labelledby="tabelLabel"
        >
          <div className="details-box col-md-6 card shadow p-0">
            <h4 className="card-header text-warning">
              <div className="w-100 d-flex justify-content-end gap-2">
                <label>
                  <a href="authorize/staffs" className="btn btn-sm btn-primary">
                    <i className="fa fa-close"></i>
                  </a>
                </label>
              </div>
              <div>
                {this.props._Id === undefined
                  ? "Add New Staff"
                  : this.state.edit === true
                  ? "Update Staff"
                  : "Staff Details"}
              </div>
            </h4>
            <div className="p-0">
              {(this.state.edit === true ||
                this.props._Id === undefined ||
                this.props._Id === null) && (
                <p className="p-4">Enter Staff details below.</p>
              )}
              <p className="border-bottom p-4"></p>
              {contents}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
